import { IExportColumnModel } from "../../../../shared/models";

export const AccountSourceOverridesColumnList: IExportColumnModel[] = [
]